var _circle, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZero(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 63,
    viewBox: "0 0 63 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 31.5,
    cy: 31.5,
    r: 31,
    fill: "#C0E7EA",
    stroke: "#50AEB5",
    strokeDasharray: "3 3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.9596 25.5554C32.7107 25.4132 32.3907 25.4843 32.2485 25.7332L29.8307 29.9287L28.2662 27.191C28.124 26.9421 27.804 26.8354 27.5551 27.0132C27.3062 27.1554 27.1996 27.4754 27.3773 27.7243L29.2618 30.9954L27.3773 34.2665C27.2351 34.5154 27.3062 34.8354 27.5551 34.9776C27.6262 35.0132 27.7329 35.0487 27.804 35.0487C27.9818 35.0487 28.1596 34.9421 28.2662 34.7643L29.8307 32.0265L30.7196 33.591C30.8262 33.7687 31.004 33.8754 31.1818 33.8754C31.2885 33.8754 31.3596 33.8398 31.4307 33.8043C31.6796 33.6621 31.7862 33.3421 31.6085 33.0932L30.3996 30.9954L33.1373 26.2665C33.2796 26.0176 33.2085 25.6976 32.9596 25.5554Z",
    fill: "#0E5D56"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47.4668 42.089H20.089C19.8046 42.089 19.5557 41.8401 19.5557 41.5557C19.5557 41.2712 19.8046 41.0223 20.089 41.0223H46.9334V26.089C46.9334 25.8046 47.1823 25.5557 47.4668 25.5557C47.7512 25.5557 48.0001 25.8046 48.0001 26.089V41.5557C48.0001 41.8757 47.7512 42.089 47.4668 42.089Z",
    fill: "#0E5D56"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M45.6885 40.3112H18.3107C18.0262 40.3112 17.7773 40.0623 17.7773 39.7778C17.7773 39.4934 18.0262 39.2445 18.3107 39.2445H45.1551V24.3112C45.1551 24.0267 45.404 23.7778 45.6885 23.7778C45.9729 23.7778 46.2218 24.0267 46.2218 24.3112V39.7778C46.2218 40.0978 45.9729 40.3112 45.6885 40.3112Z",
    fill: "#0E5D56"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M43.9111 38.5333H16.5333C16.2489 38.5333 16 38.2844 16 38V22.5333C16 22.2489 16.2489 22 16.5333 22H43.9111C44.1956 22 44.4444 22.2489 44.4444 22.5333V38C44.4444 38.32 44.1956 38.5333 43.9111 38.5333ZM17.0667 37.4667H43.3778V23.1022H17.0667V37.4667Z",
    fill: "#0E5D56"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9336 30.2843C22.9336 28.1154 23.8581 26.1954 25.3514 24.8799H19.3781C19.0936 24.8799 18.8447 25.1288 18.8447 25.4132V35.191C18.8447 35.4754 19.0936 35.7243 19.3781 35.7243H25.3514C23.8581 34.3732 22.9336 32.4532 22.9336 30.2843Z",
    fill: "#0E5D56"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M41.0671 24.8799H35.0938C36.5871 26.231 37.5115 28.151 37.5115 30.2843C37.5115 32.4177 36.5871 34.3732 35.0938 35.6888H41.0671C41.3515 35.6888 41.6004 35.4399 41.6004 35.1554V25.3777C41.6004 25.0932 41.3515 24.8799 41.0671 24.8799Z",
    fill: "#0E5D56"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZero);
export default __webpack_public_path__ + "static/media/zero.86ab65bb80ad797e1cefcfc16597ca72.svg";
export { ForwardRef as ReactComponent };